import { ExpertRole } from "../../../utils/Enums";

export const EXPERT_EMAILS: Record<ExpertRole, string[]> = {
    [ExpertRole.Specialist]: ["elvira.pistolesi@holifya.com"],
    [ExpertRole.Physician]: ["dr.gentilesalvatore@gmail.com", "filippobonaldi91@gmail.com", "alessandra.piccione91@gmail.com"],
    [ExpertRole.Nutritionist]: [
        "ccruciani44@gmail.com",
        "tsimbatatiana@gmail.com",
        "fabiana.nutrizionista@gmail.com",
        "eleonoraluvara.nutrizionista@gmail.com",
        "carolinacolonna94@gmail.com",
        "admin@holifya.com",
    ],
    [ExpertRole.Admin]: [],
    [ExpertRole.User]: []
};

export const EMAIL_TO_ROLE_MAP = Object.entries(EXPERT_EMAILS).reduce(
    (acc, [role, emails]) => {
        (emails as string[]).forEach(email => {
            acc[email] = role as ExpertRole;
        });
        return acc;
    },
    {} as Record<string, ExpertRole>
);

export const getRoleFromEmail = (email: string): ExpertRole => {
    return EMAIL_TO_ROLE_MAP[email];
};

export const ROLE_TRANSLATIONS: Record<ExpertRole, string> = {
    [ExpertRole.Specialist]: "Medico refertante",
    [ExpertRole.Physician]: "Endocrinologo",
    [ExpertRole.Nutritionist]: "Nutrizionista",
    [ExpertRole.Admin]: "Admin",
    [ExpertRole.User]: "User"
};

export const italianExpertRole = (role: ExpertRole): string => {
    return ROLE_TRANSLATIONS[role] || "Ruolo sconosciuto";
};